import moment from "moment";
import {
  TPELoginImg,
  TPESignupImg,
  TPEmyPolicy,
  TPEInvestImg,
} from "../svg/SvgImages";
import jwt_decode, { JwtPayload } from "jwt-decode";
import { Navigate } from "react-router-dom";
import { Option } from "antd/es/mentions";

export const POLICY_MASTER = "POLICY_MASTER";
export const INVESTOR = "INVESTOR";
export const PARTNER = "PARTNER";

export const CarouselList = [
  {
    img: <TPELoginImg />,
    // title: "Join Us!",
    text: "Explore our tailor-made financial solutions",
  },
  // {
  //   img: <TPELoginImg />,
  //   title: "Join Us!",
  //   text: "Explore our tailor-made financial solutions",
  // },
  // {
  //   img: <TPELoginImg />,
  //   title: "Join Us!",
  //   text: "Explore our tailor-made financial solutions",
  // },
];

export const SignUpCarousel = [
  {
    img: <TPESignupImg />,
    title: "Welcome!",
  },
];

export const InvestCarousel = [
  {
    img: <TPEInvestImg />,
    title: "Let us understand your investment goals  ",
    text: "We are here to help you attain them through our secure, high-yield, flexible, and predictable instruments",
  },
];

export const MyPolicyCarousel = {
  img: <TPEmyPolicy />,

  text: "Please fill basic details to unlock the true power of your Life Insurance policy",
};

const getValidDate = (value) => {
  if (value <= 9) {
    return `0${value}`;
  }
  return value;
};
export const get18YearBackDate = () => {
  return `${moment().year() - 18}-${getValidDate(
    moment().month() + 1
  )}-${getValidDate(moment().date())}`;
};

export const messageToast = (messageApi, msg, type = "success") => {
  if (messageApi) {
    messageApi.open({
      type: type,
      content: msg,
    });
  }
};

export const amountFormat = (amount) => {
  if (amount) {
    if (amount === 0) return 0;
    let number =
      typeof amount === "string" ? Number(amount.replace(/,/g, "")) : amount;
    return number.toLocaleString("en-IN", {
      maximumFractionDigits: 0,
      // style: "currency",
      currency: "INR",
    });
    //return number.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  } else {
    return "-";
  }
};

export const getUserInfo = () => {
  const authToken = localStorage.getItem("token");
  const userInfo = jwt_decode(authToken);
  return userInfo;
};

export const profileRedirection = (userStatus, roles, navigate) => {
  if (
    userStatus &&
    (userStatus === "NOT_UPDATED" || userStatus === "PENDING")
  ) {
    if (roles && roles === POLICY_MASTER) {
      navigate("/completephprofile");
    } else if (roles && roles === INVESTOR) {
      navigate("/investorKYC");
    } else if (roles && roles === PARTNER) {
      navigate("/partner-registration");
    }
  }
};

export const getBankAccountType = () => {
  return (
    <>
      <Option key={"SAVINGS"} value={"Savings"}>
        Savings
      </Option>
      <Option key={"CURRENT"} value={"Current"}>
        Current
      </Option>
      <Option key={"NRO"} value={"NRO"}>
        NRO
      </Option>
      <Option key={"NRE"} value={"NRE"}>
        NRE
      </Option>
      <Option key={"OD"} value={"OD"}>
        OD
      </Option>
    </>
  );
};

export const getEducationType = () => {
  return (
    <>
      <Option key={"ILLITERATE"} value={"ILLITERATE"}>
        ILLITERATE
      </Option>
      <Option key={"HS"} value={"HS"}>
        HS
      </Option>
      <Option key={"PG"} value={"PG"}>
        PG
      </Option>
      <Option key={"UG"} value={"UG"}>
        GRADUATE
      </Option>
      <Option key={"PROFESSIONAL"} value={"PROFESSIONAL"}>
        PROFESSIONAL
      </Option>
      <Option key={"OTHER"} value={"OTHER"}>
        OTHER
      </Option>
    </>
  );
};
export const obj2url = (params) =>
  Object.entries(params).reduce(
    (prev, [key, value]) => (value ? prev + `&${key}=${value}` : prev),
    ""
  );
export const getYearFilterType = () => {
  return (
    <>
      <Option key={"1yrs"} value={'{"data":{"minTenure":"0","maxTenure":1}}'}>
        Min or 1 Yrs
      </Option>
      <Option key={"2yrs"} value={'{"data":{"minTenure":1,"maxTenure":2}}'}>
        1-2 Yrs
      </Option>
      <Option key={"3yrs"} value={'{"data":{"minTenure":2,"maxTenure":3}}'}>
        2-3 Yrs
      </Option>
      <Option key={"4yrs"} value={'{"data":{"minTenure":3,"maxTenure":4}}'}>
        3-4 Yrs
      </Option>
      <Option key={"5yrs"} value={'{"data":{"minTenure":4,"maxTenure":5}}'}>
        4-5 Yrs
      </Option>
      <Option key={"6yrs"} value={'{"data":{"minTenure":6,"maxTenure":null}}'}>
        6 Yrs or Above
      </Option>
    </>
  );
};
export const getAmountFilterType = () => {
  return (
    <>
      <Option
        key={"1yrs"}
        value={
          '{"data":{"minInvestmentAmount":"0","maxInvestmentAmount":100000}}'
        }
      >
        0 - 1 Lakh
      </Option>
      <Option
        key={"2yrs"}
        value={
          '{"data":{"minInvestmentAmount":100000,"maxInvestmentAmount":200000}}'
        }
      >
        1 - 2 Lakh
      </Option>
      <Option
        key={"3yrs"}
        value={
          '{"data":{"minInvestmentAmount":200000,"maxInvestmentAmount":300000}}'
        }
      >
        2 - 3 Lakh
      </Option>
      <Option
        key={"4yrs"}
        value={
          '{"data":{"minInvestmentAmount":300000,"maxInvestmentAmount":500000}}'
        }
      >
        3 - 5 Lakh
      </Option>
      <Option
        key={"5yrs"}
        value={
          '{"data":{"minInvestmentAmount":500000,"maxInvestmentAmount":null}}'
        }
      >
        5 Lakh or Above
      </Option>
    </>
  );
};
export const getProductFilterType = () => {
  return (
    <>
      <Option key={"ULIP"} value={'{"data":{"productType":"ULIP"}}'}>
        ULIP
      </Option>
      <Option key={"TRAD"} value={'{"data":{"productType":"TRAD"}}'}>
        TRAD
      </Option>
    </>
  );
};
export const getEntityBankAccountType = () => {
  return (
    <>
      <Option key={"CURRENT"} value={"Current"}>
        Current
      </Option>

      <Option key={"OD"} value={"OD"}>
        OD
      </Option>
    </>
  );
};
